<template>
  <div v-bind:class="getClass()" class="subscription-page">
    <Hero
      title="Faça parte da transformação <br /> do mundo Fitness"
      :image="'banner.jpg'"
      :search="true"
      height="60vh"
    />
    <StepProgress
      v-if="isNotInConfig"
      :hasTests="
        opportunity.opportunity_tests &&
        opportunity.opportunity_tests.length > 0
      "
    />
    <div class="row">
      <div class="col-12 col-lg-8 mx-auto">
        <router-view :key="$route.fullPath"></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import Hero from "@/components/media/Hero.vue";
import StepProgress from "@/components/StepProgress.vue";

export default {
  name: "Subscription",

  data() {
    return {
      opportunity: {},
    };
  },

  computed: {
    isNotInConfig() {
      if (
        this.$route.name == "capa-teste" ||
        this.$route.name == "pending-tests" ||
        this.$route.name == "teste"
      ) {
        return false;
      } else {
        return true;
      }
    },
  },

  components: {
    Hero,
    StepProgress,
  },

  created() {
    this.getOpportunity();
  },

  head() {
    return this.$head({
      title: "",
    });
  },

  methods: {
    getOpportunity() {
     this.$store
        .dispatch("opportunities/getOpportunity", this.$route.params.id)
        .then((opportunity) => {
          if (opportunity) {
            this.opportunity = opportunity;

            if (
              this.opportunity.status_id != 1 &&
              this.$route.name != "capa-teste"
            ) {
              this.$swal({
                title: "Uoops",
                html: "Inscrições Encerradas",
                type: "error",
              });
              this.$router.push(`/vagas/${this.$route.params.id}`);
              return false;
            }

            if(this.opportunity.internal_recruitment == true){
              this.$swal({
                title: "Uoops",
                html: "Oportuniade exclusiva para colaboradores",
                type: "error",
              });
              this.$router.push(`/vagas/`);
              return false;
            }

            window.fbq(
              "trackSingle",
              "574552910162931",
              "InitiateApplication",
              {
                job_id: this.opportunity.id,
              }
            );
          }
        });
    },

    getClass() {
      return this.$router.history.current["path"] ===
        `/vagas/${this.$route.params["id"]}/inscricao/escala-de-crencas`
        ? "full-height"
        : "";
    },
  },
};
</script>

<style lang="scss" scoped>
.subscription-page {
  /deep/ .card-nav-tabs {
    background-color: #fff;
    position: sticky;
    top: 55px;
    z-index: 20;

    ul {
      justify-content: center;
      outline: none;

      li {
        a {
          color: color("gray");
          border-bottom: 2px solid theme-color("white");
          padding-left: 1rem;
          padding-right: 1rem;
          outline: none;
          &.active {
            border-bottom-color: theme-color("blue-ml");
            color: theme-color("blue-ml");
          }
        }
      }
    }
  }
}
</style>